// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"38952400","442":"1b71aaf5","453":"8ab44547","566":"87517ef5","648":"c4a7b7aa","658":"899af12f","739":"7c4e3e24","811":"f143b2dd"}[chunkId] + ".chunk.js";
};